import axios from "axios";

const apiaxios = axios.create({
	baseURL: process.env.REACT_APP_BACK,
});

apiaxios.interceptors.request.use((config) => {
	config.headers = {
		"x-token": localStorage.getItem("token"),
	};
	return config;
});

export { apiaxios };
